<button
  mat-icon-button
  type="button"
  [disabled]="disabled || isPending"
  [attr.aria-label]="ariaLabel"
  [matTooltip]="title"
  (click)="handleClick()"
>
  @if (!isPending) {
    <ng-content></ng-content>
  } @else {
    @if (progress === 'bar') {
      <mat-progress-bar mode="indeterminate" class="async-progress-bar"></mat-progress-bar>
    } @else {
      <mat-progress-spinner
        mode="indeterminate"
        [diameter]="20"
        strokeWidth="2"
        class="async-spinner"
      >
      </mat-progress-spinner>
    }
  }
</button>
